// extracted by mini-css-extract-plugin
export var button = "social-panel-module--button--ce548";
export var postSocial = "social-panel-module--post-social--a0c91";
export var postSocialText = "social-panel-module--post-social-text--6ebe4";